<template>
  <el-table
    ref="table"
    :key="controller.key"
    :data="tableData"
    border
    :stripe="stripe"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    @selection-change="handleSelectionChange"
    @sort-change="sortChange"
    @current-change="currentChange"
    :row-key="controller.rowKey"
    :highlight-current-row="radio"
    :show-summary="showSummary"
    :summary-method="getSummaries"
    :style="{ width: '100%' }"
    :row-style="{ height: '60px' }"
    :cell-style="{ padding: '0px' }"
  >
    <!-- :style="{minHeight:diyHeight,width: '100%'}" -->
    <el-table-column v-if="controller.selection" type="selection" align="center" width="55"></el-table-column>
    <el-table-column v-if="controller.index" label="序号" type="index" align="center" width="55"></el-table-column>

    <el-table-column
      v-for="(item, index) in tableNameList"
      :key="index"
      :prop="item.prop"
      :label="item.label"
      :width="item.width || 'auto'"
      :sortable="item.sortable ? item.sortable : false"
      :align="item.align ? item.align : 'center'"
      :show-overflow-tooltip="item.overflow ? item.overflow : false"
    >
      <template #default="scope">
        <innerSlot v-if="item.formatter" :scope="scope" :name="item.prop" :formatter="item.formatter"/>
        <slot v-else :scope="scope" :name="item.prop">{{ scope.row[item.prop] }}</slot>
      </template>
    </el-table-column>

    <el-table-column v-if="controller.isActive" fixed="right" label="操作" align="center"
                     :width="controller.width || 'auto'">
      <template slot-scope="scope">
        <slot :scope="scope" name="control"></slot>
        <!-- <el-button type="default" size="small">查看</el-button>
                <el-button @click="frozenAccount(scope.row)" type="primary" size="small">{{scope.row.frozen === 1 ?'冻结':'解冻'}}</el-button>
        <el-button @click="remove(scope.row)" type="danger" size="small">删除</el-button>-->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import innerSlot from './slotItem'

export default {
  components: {innerSlot},
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableNameList: {
      type: Array,
      default: () => [{align: 'center'}]
    },
    controller: {
      type: Object,
      default: function () {
        return {
          isActive: false,
          selection: false,
          width: 250,
          rowKey: '',
          key: 0
        }
      }
    },
    diyHeight: {
      type: String,
      default: function () {
        return ''
      }
    },
    alignText: {
      type: String,
      default: () => {
        return 'center'
      }
    },
    radio: { // 高亮
      type: Boolean,
      default: false
    },
    stripe: { // 带斑马纹
      type: Boolean,
      default: true
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    // key:{
    //   type: Number,
    //   default: 0
    // }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    sortChange(e) {
      this.$emit('sortChange', e)
    },
    clickCurrentRow(r) {
      this.$emit('clickCurrentRow', r)
    },
    currentChange(e) {
      this.$emit('currentChange', e)
    },
    summaryMethod(e) {
      this.$emit('summaryMethod', e)
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property == 'costTime') {
          const values = data.map(item => Number(item['costTime']))
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2)
          sums[index] += 'h'
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/reportTable/index.vue